import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center pt-16 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20abstract%20organic%20shapes%20in%20warm%20terracotta%20coral%20and%20sage%20green%20floating%20on%20cream%20canvas%2C%20minimal%20artistic%20composition%2C%20gentle%20gradient%20blending%2C%20airy%20atmosphere%2C%20no%20text%2C%20editorial%20quality%2C%20scandinavian%20modern%20aesthetic&width=1800&height=1200&seq=hero-bg-v2-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/30 via-background-50/15 to-background-50/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-foreground-900 font-heading leading-tight">
              acbuyspreadsheet The Ultimate Spreadsheet System for Smarter Buying and Management
            </h1>
            <p className="mt-6 text-base md:text-lg text-foreground-600 max-w-xl leading-relaxed">
              Discover how <strong>acbuyspreadsheet</strong> helps users compare, analyze, and optimize spreadsheet workflows with clarity, speed, and automation. Your complete guide to smarter purchasing decisions in 2026.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <Link
                to="/what-is-acbuyspreadsheet"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                Start Free Guide
                <i className="ri-arrow-right-up-line"></i>
              </Link>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-accent-400 text-accent-600 font-semibold text-sm hover:bg-accent-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                Visit Official Platform
                <i className="ri-external-link-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 flex justify-center">
            <div className="relative w-full max-w-md">
              <div className="rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20editorial%20flat%20lay%20of%20curated%20modern%20fashion%20items%20including%20a%20sage%20green%20hoodie%20tan%20leather%20bag%20and%20white%20sneakers%20on%20minimal%20cream%20surface%2C%20soft%20diffused%20studio%20lighting%2C%20warm%20neutral%20palette%2C%20scandinavian%20aesthetic%2C%20elegant%20composition%2C%20no%20text%20or%20logos%2C%20high%20end%20product%20photography&width=800&height=1000&seq=hero-product-v2-2026&orientation=portrait"
                  alt="acbuyspreadsheet featured products"
                  className="w-full h-auto object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-32 h-32 md:w-40 md:h-40 rounded-2xl overflow-hidden border-4 border-background-50">
                <img
                  src="https://readdy.ai/api/search-image?query=Single%20elegant%20minimal%20watch%20and%20bracelet%20set%20on%20soft%20terracotta%20pastel%20background%2C%20clean%20lines%2C%20gentle%20shadows%2C%20warm%20neutral%20tones%2C%20editorial%20style%2C%20no%20text&width=400&height=400&seq=hero-thumb-v2-2026&orientation=squarish"
                  alt="acbuyspreadsheet product detail"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}